// src/components/FeedbackSuccess.js
import React from 'react';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Box from '@mui/material/Box';

const FeedbackSuccess = () => {
    return (
        <Box textAlign="center">
            <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main' }} />
            <Typography variant="h4" component="h1" gutterBottom mt={2}>
                Vielen Dank!
            </Typography>
            <Typography variant="h6" color="text.secondary">
                Dein Feedback wurde erfolgreich übermittelt. Wir schätzen deine Hilfe.
            </Typography>
        </Box>
    );
};

export default FeedbackSuccess;